export default {"src":"/_next/static/media/rating-1.49544d30.svg","height":96,"width":512,"blurWidth":0,"blurHeight":0};